const s = {
  name: "CurrencyOmaniV2",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,11h5c2.8,0,5,2.2,5,5c0,2-1.1,3.7-2.8,4.5L19,29h-2.1l-2.6-8c-0.1,0-0.2,0-0.3,0h-3v8H9V11z M11,19h3
			c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3h-3V19z"/>
		<path class="st0" d="M26,11c-2.8,0-5,2.2-5,5v8c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5v-8C31,13.2,28.8,11,26,11z M23,16
			c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3V16z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CurrencyOmaniV2
};
